module.exports = __webpack_public_path__ + "media/images/category-bcf5366bdbead5b0abf2be66d6116105.svg";